import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Create axios instance with interceptor for JWT token
const axiosInstance = axios.create({
    baseURL: API_URL
});

// Add token to requests
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const excelService = {
    /**
     * Import Excel file and parse field data
     */
    importExcel: async (file, templateId) => {
        try {
            const formData = new FormData();
            formData.append('excel_file', file);

            const response = await axiosInstance.post(
                `/api/excel/import/${templateId}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Failed to import Excel file' };
        }
    }
};

export default excelService;
